module.exports = __webpack_public_path__ + "static/img/zhengshu1.9ff1f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengshu1.png
// module id = UHly
// module chunks = 1